import axiosInstance from "../../config/axiosInstance";

const downloadRequest = async operationId => {
  return axiosInstance.dillApi().get(`/operations/${operationId}/download`, {
    responseType: "arraybuffer"
  });
};

export default downloadRequest;
